import '../styles/Primitives.scss';
import { mergeSx } from '../_internal/styleProps';

export default function Divider({ className = '', style, sx, ...props }) {
  return <hr className={`ui-divider ${className}`.trim()} style={mergeSx(sx, style)} {...props} />;
}
